import type { FaireProductEntity } from "../../entity_types/product";

export const p_f7gcp8akvz: FaireProductEntity = {
  token: "p_f7gcp8akvz",
  type: "product",
  name: "* KIDS * Weekends at the Lake Boxy Cotton Kids T-Shirt",
  brandToken: "b_jbqutfkjxx",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/398b17e434d8c1007194a96146135f71e132fd393fd8c5093e18b85c97da713b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55f0b8926c2a6919b0cb8f3c071e7c0d9a0f555e70cd96d2928e640fd3210b47.jpeg",
    "https://cdn.faire.com/fastly/603df24ea47381f58363cd63d86687df747b3be14de87ed39cd830cc29a6e9eb.png",
    "https://cdn.faire.com/fastly/d1ca037bf578b7f54006f0cefbfae0908279014a6168b18c839b2ac0129ee71d.png",
    "https://cdn.faire.com/fastly/0d6b28003cd168ab990c5b5181dcda35321f3a2b9d3dbabef4bad6ebd1f78170.png",
    "https://cdn.faire.com/fastly/6e3e07aad65d7b78c36f6b76e3b0ec9012c2d0bb9f8425a385437d7bd4114244.png",
    "https://cdn.faire.com/fastly/7964015d31e8adb43698ef69f5bbdd474d4219d2fdae4d7fb8a9af2881aaafb9.jpeg",
    "https://cdn.faire.com/fastly/5f767fff41336bd93f4ef4e28e4446b618e02ed43544d6bd26c51b966bc3ccf4.jpeg",
    "https://cdn.faire.com/fastly/5d2adc960121712d195cc338dd9e05e9a0ba7287a05d0ef4c4cc5acb4f9381f6.jpeg",
    "https://cdn.faire.com/fastly/41d4a7e94fb837ccab5c862e295a12c4eb41a9ef1ceca02a9ce05cf54bc4ea83.png",
  ],
  priceDollars: 20.79,
  description:
    '* MADE IN USA. 6.5 OZ. 100% COTTON. *\n\nGet all of the lake vibes in our *NEW* Kids boxy Weekends at the Lake inspired tshirt!\n\n- Features "Weekends at the Lake - No Wake Zone" across the front and back in a red ink\n\n\n- Screen print transfer that is heat pressed onto each tshirt\n\n- Tshirt is a super soft vintage wash that gets softer after each wash, features drop shoulder and a double stitch collar\n\n- Meant to be a Boxy fit\n\n- Refer to photos for size references on how the tees fit -- Model in Green is typically a size 2T wearing a size 4/5 for an oversized look | Model in Black is typically a size 5T wearing a size 6 for an oversized look\n\n- 100% Cotton\n\n* due to screens and filters colors may vary slightly to photos - colors on mock up most closely represent the color of the actual item as our product photos have filters on them that can affect the colors / lighting *',
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:36.325Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
